import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import actionVehicleCategories from '~/modules/master/redux/actions/vehicle-categories'

const useVehicleCategories = () => {
  const data = useSelector((state) => get(state, 'master.vehicleCategories'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(actionVehicleCategories, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useVehicleCategories
